import { DEAL_LOSS_REASONS, DEAL_WIN_REASONS, } from './enums.js';
/**
 * Probability, weighted value and outcome — all derived, none stored (rule 11).
 * DECISIONS.md §18.
 *
 * These are the only definitions. The API, the reports and the Excel exports
 * all call them, so a figure on screen and one in a workbook cannot disagree.
 */
/**
 * How likely a deal at each stage is to close, in percent.
 *
 * The single source of truth, and a code constant the owner can change. They
 * are judgement, not measured from MEFOSA's history: revisit once real win-rate
 * data exists.
 */
export const DEFAULT_STAGE_PROBABILITY = {
    1: 10,
    2: 30,
    3: 90,
    4: 100,
    5: 100,
};
/**
 * Lost is checked FIRST. A deal can sit at a closed stage and still be marked
 * not awarded or cancelled, and the state is the more deliberate statement.
 */
export function dealOutcome(deal) {
    if (deal.state === 'not_awarded' || deal.state === 'cancelled')
        return 'lost';
    return deal.stage >= 4 ? 'won' : 'open';
}
/**
 * The percentage a deal actually counts at.
 *
 * An override only speaks to a deal still in play, so a won or lost deal ignores
 * it. A stage change clears it on the server; see probabilityAfterStageChange.
 */
export function effectiveProbability(deal) {
    const outcome = dealOutcome(deal);
    if (outcome === 'lost')
        return 0;
    if (outcome === 'won')
        return 100;
    return deal.probabilityPercent ?? DEFAULT_STAGE_PROBABILITY[deal.stage];
}
/**
 * Value times probability, in the deal's own currency's minor units.
 *
 * Null for a deal with no figure, never zero: a note-only deal ("> 10,000 $")
 * is unknown, and zero would claim it is worth nothing.
 */
export function weightedValueMinor(deal) {
    if (deal.projectValueMinor == null)
        return null;
    return Math.round((deal.projectValueMinor * effectiveProbability(deal)) / 100);
}
/** Whether a reason fits an outcome. An open deal has no outcome to explain. */
export function isReasonAllowed(outcome, reason) {
    if (outcome === 'lost')
        return DEAL_LOSS_REASONS.includes(reason);
    if (outcome === 'won')
        return DEAL_WIN_REASONS.includes(reason);
    return false;
}
//# sourceMappingURL=dealForecast.js.map